<nz-tag [nzColor]="pfColor">
    <span class="chip__content">
        @if (icon) {
            <pf-icon [iconType]="icon" size="md"></pf-icon>
        }
        <span><ng-content></ng-content></span>
    </span>
</nz-tag>
